import PropTypes from 'prop-types'

export default PropTypes.oneOfType([
  PropTypes.node,
  PropTypes.arrayOf([PropTypes.node])
])
